import {trpc} from '@/app/utils/trpc';
import {useAiThinking} from '@/app/ai/useAiThinking';

export function useIsFlowBusy() {
  const utils = trpc.useUtils();
  const isGenerating = useAiThinking();

  const isChangingFlowVersion = utils.flow.setFlowVersion.isMutating() > 0;

  return isGenerating || isChangingFlowVersion;
}
